import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../utils/commonfunction";
import * as categoryServices from "../../services/category.services";
import { useTranslation } from "react-i18next";

const CategoryView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("link_category"), url: "/admin/category/list/1" },
    { title: t("link_view"), url: "" },
  ];

  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    categoryServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_category_view")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("list_heading_title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.title ? showdefault.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_type")}</th>
                          <td>
                            {showdefault && showdefault?.type ? t(`label_${showdefault.type}`) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_size")}</th>
                          <td>
                            {showdefault?.sizes?.length > 0
                              ? showdefault.sizes
                                  .map((s) => (typeof s === "string" ? s : s?.title))
                                  .filter(Boolean)
                                  .join(", ") || "-"
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_image")}</th>
                          <td><img src={showdefault && showdefault.image ? showdefault.image : ""} alt={showdefault?.title} style={{ height: "100px" }} /></td>
                        </tr>
                        <tr>
                          <th>{t("label_status")}</th>
                          <td>{showdefault && showdefault?.status === 0 ? toHtml(showStatus(showdefault.status)) : toHtml(showStatus(showdefault.status))}</td>
                        </tr>
                        <tr>
                          <th>{t("label_sub_category")}</th>
                          <td>
                            {showdefault?.subCategories?.length > 0
                              ? showdefault.subCategories.map((sub, index) => (
                                <span key={sub._id}>
                                  {sub.title.split(" ")}
                                  {index < showdefault.subCategories.length - 1 ? ", " : ""}
                                </span>
                              ))
                              : "-"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <h6 className="main-content-label mb-3">{t("label_description")}:</h6> */}
                    {/* <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div> */}
                    {/* <div
                      className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html: showdefault && showdefault?.description ? showdefault.description : "N/A",
                      }}></div> */}
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryView;
